import React, { forwardRef } from 'react';
import './Container.scss';

export type ContainerProps = {
    padding?:
        | 'none'
        | 'small'
        | 'small-medium'
        | 'medium small'
        | 'medium small-medium'
        | 'medium'
        | 'large'
        | 'medium large'
        | 'medium-large-spacing large-spacing';
    row?: boolean;
    flexRow?: boolean;
    column?: boolean;
    greyed?: boolean;
    center?: boolean;
    bordered?: 'grey';
    height?: 'fill';
    radius?: 'small' | 'medium' | 'large' | 'none';
} & React.HTMLAttributes<HTMLDivElement>;

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
    (
        {
            children,
            className,
            padding = 'medium',
            row = false,
            flexRow = false,
            column = false,
            greyed = false,
            center = false,
            bordered,
            height,
            radius,
            ...props
        },
        ref
    ) => {
        return (
            <div
                data-padding={padding}
                data-row={row}
                data-flex-row={flexRow}
                data-column={column}
                data-greyed={greyed}
                data-center={center}
                data-bordered={bordered}
                data-height={height}
                data-radius={radius}
                className={`container ${className ?? ''}`}
                ref={ref}
                {...props}
            >
                {children}
            </div>
        );
    }
);
